import { ref } from "vue";
import { defineStore } from "pinia";
import { getCurrentUserFeatureFlags } from "@/shared/services/getCurrentUserFeatureFlags.service";

export const useFeatureFlagsStore = defineStore("FeatureFlags", () => {
  const enabledFeatures = ref<string[]>([]);
  const isFetchingFeatureFlags = ref(false);
  const hasErrorWhileFetchingFeatureFlags = ref(false);

  const onFetchingFeatureFlags = async (customerId: string) => {
    try {
      isFetchingFeatureFlags.value = true;
      enabledFeatures.value = await getCurrentUserFeatureFlags(customerId);
    } catch {
      enabledFeatures.value = [];
      hasErrorWhileFetchingFeatureFlags.value = true;
    } finally {
      isFetchingFeatureFlags.value = false;
    }
  };

  const isFeatureEnabled = (feature: string) =>
    enabledFeatures.value.includes(feature);

  const resetData = () => {
    enabledFeatures.value = [];
    isFetchingFeatureFlags.value = false;
    hasErrorWhileFetchingFeatureFlags.value = false;
  };

  return {
    enabledFeatures,
    isFetchingFeatureFlags,
    hasErrorWhileFetchingFeatureFlags,
    onFetchingFeatureFlags,
    isFeatureEnabled,
    resetData,
  };
});
